module.exports = "../../../../platform/assets/pageMainIcon/business_danjuweihulei6.svg";